var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dragscroll",rawName:"v-dragscroll"}],staticClass:"main-page",class:{ 'record-mode': _vm.recordLayerPattern },on:{"wheel":function($event){return _vm.$emit('wheel', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }